import { ROUTE } from '../../../routes';
import { api } from '../../../configs/api';
import SharedPropsService from '../../../SharedPropsService';
import { getAppHeader } from '../../../configs/config';
import { InputStateToken } from '@voltmoney/schema';
import { CREDIT_STATUS, UPDATE_REQUEST_TYPE } from '../../../configs/constants';
import { isMobile } from '../../../configs/utils';
let phoneNumber = '';
let counter = 0;
export const accountDetails = async (action, _datastore, { navigate, setDatastore, asyncStorage }) => { };
export const goBack = async (action, _datastore, { goBack }) => {
    await goBack();
};
export const needHelp = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const editUserDetails = async (action, _datastore, { network, setDatastore }) => {
    const requestType = action?.payload?.requestType;
    const user = await SharedPropsService.getUser();
    const borrowerAccountId = user?.linkedApplications[0].accountId;
    const creditStatus = user?.linkedCredits[0]?.creditStatus;
    await setDatastore(action.routeId, 'accountDetailsDC', {
        errorModal: false,
        otpModal: false,
        otpErrorModal: false,
        closureModal: false,
        setUpModal: false,
        modalHeight: 0,
        errorMessage: '',
        counter: counter++,
    });
    if (creditStatus === CREDIT_STATUS.ACTIVE || creditStatus === CREDIT_STATUS.APPROVED_NOT_DISBURSED) {
        const response = await network.get(`${api.updateUserDetails}${borrowerAccountId}`, { headers: await getAppHeader(), handleFromMF: true });
        if (response?.status === 200) {
            await setDatastore(action.routeId, 'accountDetailsDC', {
                errorModal: false,
                otpModal: true,
                closureModal: false,
                setUpModal: false,
                errorMessage: '',
                counter: counter++,
            });
        }
        else if (response.response.data.voltErrorCode === "ACCOUNT_BLOCKED_FROM_OTP") {
            await setDatastore(action.routeId, 'accountDetailsDC', {
                errorModal: false,
                otpModal: false,
                otpErrorModal: true,
                closureModal: false,
                setUpModal: false,
                modalHeight: isMobile() ? 264 : 240,
                errorMessage: response?.response?.data?.message,
                counter: counter++,
            });
        }
        else {
            await setDatastore(action.routeId, 'accountDetailsDC', {
                errorModal: true,
                otpModal: false,
                closureModal: false,
                setUpModal: false,
                modalHeight: 210,
                errorMessage: 'Something went wrong',
                counter: counter++,
            });
        }
    }
    else if (creditStatus === CREDIT_STATUS.PENDING_CLOSURE) {
        await setDatastore(action.routeId, 'accountDetailsDC', {
            errorModal: false,
            otpModal: false,
            closureModal: true,
            setUpModal: false,
            modalHeight: isMobile() ? 284 : 258,
            errorMessage: "Can't update details when account closure is in progress.",
            counter: counter++,
        });
    }
    else {
        await setDatastore(action.routeId, 'accountDetailsDC', {
            errorModal: false,
            otpModal: false,
            closureModal: false,
            setUpModal: true,
            modalHeight: isMobile() ? 284 : 258,
            errorMessage: 'You will be able to update your details once your account set up is complete.',
            counter: counter++,
        });
    }
};
export const verifyOtp = async (action, _datastore, { network, setDatastore, navigate }) => {
    const otp = action?.payload?.otp;
    const requestType = action?.payload?.requestType;
    const user = await SharedPropsService.getUser();
    const borrowerAccountId = user?.linkedApplications[0].accountId;
    await setDatastore(action.routeId, "accountDetailsDC", {
        state: InputStateToken.DEFAULT,
        counter: counter++,
    });
    const response = await network.post(`${api.verifyUserMobileDetails}`, {
        otp: otp,
        borrowerAccountId: borrowerAccountId
    }, { headers: await getAppHeader(), handleFromMF: true });
    if (response?.status === 200) {
        await setDatastore(action.routeId, "accountDetailsDC", {
            otpModal: false,
            counter: counter++,
        });
        if (requestType === UPDATE_REQUEST_TYPE.PHONE_NUMBER) {
            await navigate(ROUTE.UPDATE_LOGIN_SCREEN);
        }
        else
            await navigate(ROUTE.UPDATE_EMAIL_SCREEN);
    }
    else {
        if (response.response.data.voltErrorCode === "ACCOUNT_BLOCKED_FROM_OTP") {
            await setDatastore(action.routeId, "accountDetailsDC", {
                state: InputStateToken.DISABLED,
                caption: { error: response.response.data.message },
                otpLimitExceeded: true,
                counter: counter++,
            });
        }
        else {
            await setDatastore(action.routeId, "accountDetailsDC", {
                state: InputStateToken.ERROR,
                caption: { error: response.response.data.message },
                counter: counter++,
            });
        }
    }
};
export const resendOtp = async (action, _datastore, { network, setDatastore }) => {
    const user = await SharedPropsService.getUser();
    const borrowerAccountId = user?.linkedApplications[0].accountId;
    const response = await network.get(`${api.updateUserDetails}${borrowerAccountId}`, { headers: await getAppHeader(), handleFromMF: true });
    if (response?.status === 200) {
        await setDatastore(action.routeId, "accountDetailsDC", {
            state: InputStateToken.SUCCESS,
            counter: counter++,
        });
    }
    else {
        if (response.response.data.voltErrorCode === "ACCOUNT_BLOCKED_FROM_OTP") {
            await setDatastore(action.routeId, "accountDetailsDC", {
                state: InputStateToken.DISABLED,
                caption: { error: response.response.data.message },
                otpLimitExceeded: true,
                counter: counter++,
            });
        }
        else {
            await setDatastore(action.routeId, "accountDetailsDC", {
                state: InputStateToken.ERROR,
                caption: { error: response.response.data.message },
                counter: counter++,
            });
        }
    }
};
export const handleCloseModal = async (action, _datastore, { setDatastore }) => {
    await setDatastore(action.routeId, 'accountDetailsDC', {
        errorModal: false,
        otpModal: false,
        closureModal: false,
        setUpModal: false,
        otpErrorModal: false,
        counter: counter++,
    });
};
export const handleCloseOtpModal = async (action, _datastore, { setDatastore }) => {
    await setDatastore(action.routeId, "accountDetailsDC", {
        state: InputStateToken.DEFAULT,
        counter: counter++,
    });
};
